import React from 'react'
import { Pagination } from 'react-admin';

const ListPagination = props => <Pagination rowsPerPageOptions={[25, 50, 75, 100]} {...props} />;

export default ListPagination;